import type { RenderLeafProps } from 'slate-react';

import React, { useRef } from 'react';

import classes from './style.module.scss';

type Props = RenderLeafProps;

const GlossaryTermLeaf = ({ children, ...props }: Props) => {
  const ref = useRef(null);

  return (
    <span {...props} ref={ref} className={classes.GlossaryTermLeaf}>
      {children}
    </span>
  );
};

export default GlossaryTermLeaf;
